exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'Montserrat';\n  src: url(\"https://s3.amazonaws.com/cdn.agentdesks.com/fonts/Montserrat/Montserrat-SemiBold.ttf\") format('truetype');\n  font-weight: 600;\n  font-display: swap;\n  font-style: normal;\n}", ""]);

// exports
